import { Link } from "react-router-dom";
import { PHONE_HREF, PHONE, BADGE_URL } from "../../../mocks/businessData";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image with Ken Burns */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://uppercanadalandscape.com/wp-content/uploads/2026/03/Large-Stone-Patio-and-Outdoor-Kitchen-with-Lake-View.webp"
          alt="Premium stone patio with outdoor kitchen overlooking a lake &ndash; Upper Canada Landscape London Ontario"
          className="w-full h-full object-cover object-top animate-kenburns"
          fetchPriority="high"
        />
      </div>

      {/* Cinematic gradient layers */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-black/25"></div>

      {/* Vertical accent bar */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-rust-600/60 to-transparent hidden lg:block"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 pt-36 pb-24">
        <div className="max-w-3xl">
          {/* Pre-headline eyebrow */}
          <div
            className="reveal visible flex items-center gap-4 mb-7"
            style={{ transitionDelay: "0ms" }}
          >
            <span className="h-px w-12 bg-rust-400 block flex-shrink-0"></span>
            <span className="font-sans text-xs font-semibold tracking-[0.28em] uppercase text-rust-300">
              London, Ontario &nbsp;&mdash;&nbsp; Established 1994
            </span>
          </div>

          {/* Main headline */}
          <h1
            className="reveal visible font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-7"
            style={{ transitionDelay: "120ms" }}
          >
            Where Vision<br />
            <em className="not-italic text-stone-200">Becomes</em>{" "}
            <span className="text-rust-300">Landscape.</span>
          </h1>

          {/* Sub-headline */}
          <p
            className="reveal visible font-sans text-lg md:text-xl text-stone-300 leading-relaxed mb-10 max-w-lg"
            style={{ transitionDelay: "220ms" }}
          >
            Custom patios, water features, stone hardscape, and synthetic turf &mdash;
            designed and built in-house by London&rsquo;s most trusted landscape team.
          </p>

          {/* CTAs */}
          <div
            className="reveal visible flex flex-col sm:flex-row gap-4 mb-12"
            style={{ transitionDelay: "320ms" }}
          >
            <Link
              to="/#contact"
              onClick={() => {
                setTimeout(() => {
                  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className="whitespace-nowrap inline-flex items-center justify-center gap-2.5 bg-rust-700 hover:bg-rust-800 text-white font-sans text-sm font-semibold px-9 py-4 rounded-sm transition-all duration-200 cursor-pointer tracking-wide"
            >
              <i className="ri-calendar-check-fill"></i>
              Schedule a Design Consultation
            </Link>
            <a
              href={PHONE_HREF}
              className="whitespace-nowrap inline-flex items-center justify-center gap-2.5 border border-white/35 hover:bg-white/10 text-white font-sans text-sm font-semibold px-9 py-4 rounded-sm transition-all duration-200 cursor-pointer tracking-wide"
            >
              <i className="ri-phone-fill"></i>
              Call {PHONE}
            </a>
          </div>

          {/* Social proof strip — verified claims only */}
          <div
            className="reveal visible flex flex-wrap items-center gap-5"
            style={{ transitionDelay: "400ms" }}
          >
            <div className="flex items-center gap-2 bg-white/8 border border-white/15 rounded-full px-4 py-2">
              <i className="ri-shield-check-fill text-rust-400 text-xs"></i>
              <span className="font-sans text-xs text-stone-200 font-medium">Licensed &amp; Insured</span>
            </div>
            <div className="flex items-center gap-2 bg-white/8 border border-white/15 rounded-full px-4 py-2">
              <i className="ri-hammer-fill text-rust-400 text-xs"></i>
              <span className="font-sans text-xs text-stone-200 font-medium">In-House Artisan Crews</span>
            </div>
            <div className="flex items-center gap-2 bg-white/8 border border-white/15 rounded-full px-4 py-2">
              <i className="ri-map-pin-2-fill text-rust-400 text-xs"></i>
              <span className="font-sans text-xs text-stone-200 font-medium">London, Ontario &mdash; Est. 1994</span>
            </div>
          </div>
        </div>
      </div>

      {/* 30-year badge — floating top right */}
      <div className="absolute top-28 right-4 md:right-10 lg:right-16 hidden md:flex flex-col items-center animate-float">
        <div className="w-28 h-28 lg:w-32 lg:h-32">
          <img
            src={BADGE_URL}
            alt="Upper Canada Landscape &ndash; 30 years serving London Ontario"
            className="w-full h-full object-contain drop-shadow-lg"
          />
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="font-sans text-[10px] text-stone-500 tracking-[0.2em] uppercase">Scroll</span>
        <div className="w-px h-10 bg-stone-600 animate-scroll-pulse"></div>
      </div>
    </section>
  );
}
